(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "react", "lodash", "prop-types", "@fiverr/i18n/singleton", "@fiverr/gofor"], factory);
	else if(typeof exports === 'object')
		exports["GigCards"] = factory(require("classnames"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"));
	else
		root["GigCards"] = factory(root["classNames"], root["React"], root["_"], root["PropTypes"], root["i18n"], root["goforFactory"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_JgyH__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_PbPb__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_jPm4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition